module.exports = __webpack_public_path__ + "static/img/资金结算.ba7a65d1.png";